/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: collaborators-grid-search-view-component
 *
 * Created by sjacobs on 2/1/18.
 */
'use strict';

function CollaboratorsGridSearchViewController(
    this: JS5Object,
    _: JS5Object,
    $location: JS5Object,
    $routeParams: JS5Object,
    uiGridConstants: JS5Object,
    CollaboratorsResourceFactory: JS5Object,
    CollaboratorsService: JS5Object,
    ModalService: JS5Object,
    NavbarUtilService: JS5Object,
    PaginationService: JS5Object,
    PermissionsService: JS5Object,
    SearchFilterService: JS5Object
): void {

    let handleGridDataQuery = (gridData: JS5Object, responseHeaders: JS5Function) => {
        PaginationService.parseResponseHeaders(responseHeaders());
        PaginationService.pageData = gridData;
    };

    let navigateToCollaboratorsEditView = (row: JS5Object): void => {
        $location.url(`/meta/collaborators/edit/${row.id}`);
    };

    this.getData = (): void => {
        this.searchText = $location.search().searchText || null;
        let criteria = {
            fetchOffset: this.pagingOptions.pageSize * (this.pagingOptions.currentPage - 1),
            fetchLimit: this.pagingOptions.pageSize,
            searchString: this.searchText
        };
        this.loadingIndicator.show = true;
        this.searchText = $location.search().searchText || null;

        CollaboratorsService.getAllCollaborators(criteria, handleGridDataQuery).then((collaborators: JS5Object[]): void => {
            this.gridOptions.data = collaborators;
            this.loadingIndicator.show = false;
        });
    };
    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: () => {
                return _.get(this, 'permissions.write');
            },
            onClick: () => {
                ModalService.showCreateCollaboratorModal(this.checkToSaveNewCollaborator);
            }
        },
        {
            label: 'Edit',
            enabled: () => {
                const selectedRows = this.collaboratorsGridApi.selection.getSelectedRows();
                return selectedRows && selectedRows.length && _.get(this, 'permissions.write');
            },
            onClick: () => {
                const selectedRows = this.collaboratorsGridApi.selection.getSelectedRows();
                if (selectedRows && selectedRows.length) {
                    let selectedCollaborator = selectedRows[0];
                    if (selectedCollaborator && selectedCollaborator.id && this.permissions.write) {
                        $location.url(`/meta/collaborators/edit/${selectedCollaborator.id}`);
                    }
                }
            }
        },
        {
            label: 'Delete',
            enabled: () => {
                const selectedRows = this.collaboratorsGridApi.selection.getSelectedRows();
                return selectedRows && selectedRows.length && _.get(this, 'permissions.write');
            },
            onClick: () => {
                const selectedRows = this.collaboratorsGridApi.selection.getSelectedRows();
                if (selectedRows && selectedRows.length) {
                    let selectedCollaborator = selectedRows[0];
                    if (selectedCollaborator && selectedCollaborator.id) {
                        ModalService.showMessageModal({
                            messageText: 'Are you sure you want to delete this Collaborator',
                            pullCancelLeft: true,
                            title: 'Delete Collaborator',
                            windowClass: 'confirm-modal-sm',
                            showOK: true
                        }, () => {
                            this.loadingIndicator.show = true;
                            CollaboratorsService.deleteCollaborator(selectedCollaborator).then(() => {
                                this.loadingIndicator.show = false;
                                this.getData();
                            });
                        });
                    }
                }
            }
        }
    ];
    let onPaginationChanged = (): void => {
        this.getData();
    };


    this.checkToSaveNewCollaborator = (collaboratorToSave: JS5Object) => {
        this.loadingIndicator.show = true;
        CollaboratorsService.getAllCollaborators({
            searchString: collaboratorToSave.displayName
        }, () => {
        }).then((collaborators: Array<JS5Object>) => {
            this.loadingIndicator.show = false;
            const matches = collaborators.filter((collaborator) => {
                return collaborator.displayName === collaboratorToSave.displayName;
            });
            if (matches.length) {
                ModalService.showMessageModal({
                        messageText: 'A collaborator with this display name already exists in the system, would you like to continue to create a duplicate?',
                        pullCancelLeft: true,
                        title: 'Duplicate Collaborator Found',
                        showOK: true
                    },
                    () => {
                        this.saveNewCollaborator(collaboratorToSave);
                    },
                    this.cancelCreateDuplicateCollaborator
                );
            } else {
                this.saveNewCollaborator(collaboratorToSave);
            }
        });
    };
    this.cancelCreateDuplicateCollaborator = () => {
        ModalService.showCreateCollaboratorModal(this.checkToSaveNewCollaborator)
    };
    this.saveNewCollaborator = (newCollaborator: JS5Object) => {
        CollaboratorsService.saveNewCollaborator(newCollaborator).then((savedCollaboraor) => {
            this.getData();
        });
    };
    this.executeSearch = (): void => {
        this.collaboratorsGridApi.grid.refresh();
    };

    this.paginationPageSizeChanged = () => {
        this.pagingOptions.currentPage = 1;
        onPaginationChanged();
    };

    this.paginationPrevPageHandler = () => {
        --this.pagingOptions.currentPage;
        onPaginationChanged();
    };
    this.paginationJumpToPageHandler = () => {
        onPaginationChanged();
        this.getData();
    };

    this.paginationNextPageHandler = () => {
        ++this.pagingOptions.currentPage;
        onPaginationChanged();
    };

    this.onRowDblClick = (row: JS5Object) => {
        navigateToCollaboratorsEditView(row.entity);
    };

    let columnDefinitions = [
        {
            field: 'displayName',
            displayName: 'Name',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'sortName',
            displayName: 'Sort Name',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'nickname',
            displayName: 'Nickname',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'iMDbNumber',
            displayName: 'IMDB#',
            cellTemplate: 'components/visual/grid/hyperlink-template.html'
        }
    ];

    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: false,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: false,
        columnDefs: columnDefinitions,
        onRegisterApi: (gridApi: JS5Object): void => {
            this.collaboratorsGridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        data: []
    };

    this.paginationDefs = {
        paginationPrevPageHandler: this.paginationPrevPageHandler,
        paginationNextPageHandler: this.paginationNextPageHandler,
        paginationPageSizeChanged: this.paginationPageSizeChanged,
        paginationJumpToPageHandler: this.paginationJumpToPageHandler,
        pagingOptions: PaginationService,
    };

    this.$onInit = () => {
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        PaginationService.resetToDefaultValues();
        this.searchText = '';
        this.pagingOptions = PaginationService;
        NavbarUtilService.viewSearchFunction = this.getData;
        SearchFilterService.populateCriteriaFromLocationSearch();
        PermissionsService.getReadWritePermissions(CollaboratorsService.permissionViewState).then((permissions: JS5Object) => {
            this.permissions = permissions;
            this.getData();
        });
    };

    this.$onDestroy = (): void => {
        NavbarUtilService.viewSearchFunction = null;
    };

}

angular.module('prism-ui.collaborators').component('collaboratorsGridSearchView', {
    controller: CollaboratorsGridSearchViewController,
    templateUrl: 'meta/collaborator/searchView/collaborators-grid-search-view-template.html',
    bindings: {}
});
